<!-- 
  Use ngx-loading-bar/http-client when load this page. 
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>

<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <ng-container *ngIf="cart?.id; else loading">
      <!-- Breadcrumbs -->
      <nav class="flex mt-12" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div>
              <a [routerLink]="['/']" class="text-gray-400 hover:text-pink-800">
                <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only">Início</span>
              </a>
            </div>
          </li>

          <li>
            <div class="flex items-center">
              <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">Carrinho</a>
            </div>
          </li>
        </ol>
      </nav>

      <ng-container *ngIf="profile === undefined">
        <div class="mt-4 lg:mt-8 mx-1 border rounded-lg p-4">
          <div class="space-y-3">
            <h3 class="text-pink-800 text-lg font-bold">Você na Casa de Gê</h3>
            <p class="text-[.9rem]">Que tal ter acesso a promoções exclusivas para finalizar sua compra?</p>
            <div class="flex items-center space-x-3">
              <button [routerLink]="['/b']" class="bg-[#FFBE0B] rounded-lg text-black font-semibold text-[.68rem] p-2 lg:text-[.8rem] hover:bg-amber-600">Entre com seu Login</button>
              <p class="text-xs lg:text-[.7rem]">ou</p>
              <button [routerLink]="['/b']" class="bg-[#FFBE0B] rounded-lg text-black font-semibold text-[.68rem] p-2 lg:text-[.8rem] hover:bg-amber-600">Faça seu Cadastro</button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="cart.counter_item == 0">
        <div class="py-16">
          <p class="text-center">Seu carrinho está vazio.</p>
        </div>
      </ng-container>
      <ng-container *ngIf="cart.counter_item > 0">
        <form class="py-16 lg:grid lg:grid-cols-12 lg:items-start lg:gap-x-12 xl:gap-x-16">
          <section aria-labelledby="cart-heading" class="lg:col-span-7">
            <h2 id="cart-heading" class="sr-only">Items no seu carrinho</h2>

            <ul role="list" class="divide-y divide-gray-200 border-t border-b border-gray-200">
              <ng-container *ngFor="let cartProduct of cart.products;">
                <li class="flex py-6">
                  <div class="flex-shrink-0">
                    <ng-container *ngIf="cartProduct.product.img_spotlight != ''">
                      <img src="{{cartProduct.product.img_spotlight}}" alt="{{cartProduct.product.name}}" class="h-24 w-24 rounded-md object-contain object-center sm:h-48 sm:w-48" />
                    </ng-container>
                    <ng-container *ngIf="cartProduct.product.img_spotlight == ''">
                      <img src="/assets/images/no_imagem.png" alt="{{cartProduct.product.name}}" class="h-24 w-24 rounded-md object-contain object-center sm:h-48 sm:w-48" />
                    </ng-container>
                  </div>

                  <div class="ml-4 flex flex-1 flex-col justify-between sm:ml-6">
                    <div class="relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0">
                      <div>
                        <div class="flex justify-between">
                          <h3 class="text-sm">
                            <a [routerLink]="['/p/'+cartProduct.product.url_handle+'/id/'+cartProduct.product.id]" class="font-medium text-gray-700 hover:text-gray-800">{{cartProduct.product.name}}</a>
                          </h3>
                        </div>
                        <div class="mt-1 flex text-xs">
                          <p class="text-gray-500">SKU: {{cartProduct.product.code_sku}}</p>
                        </div>
                        <p class="mt-1 text-sm font-medium text-gray-900">UN: R${{cartProduct.price | number:'1.2-2'}}</p>
                      </div>

                      <div class="mt-4 sm:mt-0 sm:pr-9">
                        <label for="quantity-0" class="sr-only">Quantidade</label>

                        <div class="absolute top-0 right-0">
                          <button title="Quantidade" (click)="clientMarketplaceCartProductServiceDestroy(cartProduct);" [disabled]="messageProcess" type="button" class="-m-2 inline-flex p-2 text-gray-400 hover:text-gray-500">
                            <span class="sr-only">Remover Produto</span>
                            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                              <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="flex items-center justify-between">
                      <button title="Diminuit" (click)="clientMarketplaceCartProductServiceUpdateLessProduct(cartProduct)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-pink-800" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
                        </svg>
                      </button>

                      <input
                        type="number"
                        min="1"
                        [(ngModel)]="cartProduct.inventory_quantity"
                        #cartProduct.inventory_quantity="ngModel"
                        (blur)="clientMarketplaceCartProductServiceUpdate(cartProduct);"
                        [disabled]="messageProcess"
                        [ngModelOptions]="{standalone: true}"
                        class="border-transparent text-center text-lg text-pink-800 font-bold rounded-lg focus:ring-pink-400 focus:border-pink-800 block w-24 p-2.5"
                      />

                      <button title="Aumentar" (click)="clientMarketplaceCartProductServiceUpdateMoreProduct(cartProduct)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-pink-800 text-bold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                        </svg>
                      </button>
                    </div>

                    <ng-container *ngIf="cartProduct.price_discount > 0">
                      <div class="rounded-lg border border-green-600 bg-green-100 p-2 mt-2">
                        <p class="font-bold text-xs uppercase text-green-800">Alerta de economia</p>
                        <p class="text-xs text-green-900">Você economizou R$ {{cartProduct.price_discount_accumulated | number:'1.2-2'}}.</p>
                      </div>
                    </ng-container>
                  </div>
                </li>
              </ng-container>
            </ul>
          </section>

          <!-- Order summary -->
          <section aria-labelledby="summary-heading" class="mt-16 rounded-lg bg-gray-50 px-4 py-6 sm:p-6 lg:col-span-5 lg:mt-0 lg:p-8">
            <h2 id="summary-heading" class="text-lg font-medium text-gray-900">Resumo da Compra</h2>
            <ng-container *ngIf="cart.delivery_info?.delivery_free == 'no' && cart.delivery_info?.delivery_could_be_free == 'yes'">
              <div class="mx-1 mb-8 mt-3 lg:m-0">
                <div class="rounded-lg border border-blue-600 bg-blue-100 p-2 mt-2">
                  <p class="text-xs text-blue-700 lg:text-sm">Temos um ❤ disponível para você!</p>
                  <p class="font-bold text-xs uppercase text-blue-700 lg:text-sm">Frete Grátis</p>
                </div>
              </div>
            </ng-container>
            <dl class="mt-6 space-y-4">
              <div class="flex items-center justify-between">
                <dt class="text-sm text-gray-600">Subtotal ({{cart.counter_item}} itens)</dt>
                <dd class="text-sm font-medium text-gray-900">R${{cart.price_gross | number:'1.2-2'}}</dd>
              </div>

              <div class="flex items-center justify-between border-t border-gray-200 pt-4">
                <dt class="text-sm text-gray-600">Frete</dt>
                <div class="flex justify-between items-center space-x-2">
                  <ng-container *ngIf="cart.awaiting_user_apply_delivery_method">
                    <input type="text" value="{{cart.zipcode}}" placeholder="CEP" #zipcode class="focus:outline-none border- border-gray-200 rounded-lg placeholder-gray-400 px-6 py-2 text-sm w-44" placeholder="Digite seu CEP" />
                    <button (click)="collectiveMarketplaceCartServicePriceDelivery();" class="bg-[#FFBE0B] rounded-lg text-black px-4 py-3 text-sm font-medium hover:bg-amber-500">Calcular</button>
                  </ng-container>

                  <ng-container *ngIf="cart.delivery_free == 'yes'">
                    <dd class="text-sm font-medium text-gray-900">Grátis</dd>
                  </ng-container>
                  <ng-container *ngIf="cart.price_delivery != 0 && cart.delivery_free == 'no'">
                    <dd class="text-sm font-medium text-gray-900">R${{cart.price_delivery | number:'1.2-2'}}</dd>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="cart.delivery_info?.delivery_free == 'no' && cart.delivery_info?.delivery_could_be_free == 'no' && cart?.delivery_info.diff_amount_delivery_free > 0 && cart?.delivery_info.diff_amount_delivery_free <= cart?.delivery_info.min_amount_delivery_free">
                <div class="mx-1 mb-8 -mt-3 lg:m-0">
                  <div class="rounded-lg border border-blue-600 bg-blue-100 p-2 mt-2 flex space-x-2">
                    <p class="text-xs text-blue-700 lg:text-sm">Adicione mais <span class="font-bold text-xs uppercase text-blue-700 lg:text-sm">R${{cart.delivery_info.diff_amount_delivery_free | number:'1.2-2'}}</span> em produtos e tenha <span class="font-bold text-xs uppercase text-blue-700 lg:text-sm">frete grátis</span> na sua compra</p>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="cart.price_discount > 0">
                <div class="flex items-center justify-between border-t border-gray-200 pt-4">
                  <dt class="text-sm text-gray-600">Desconto<br /><small class="d-block" *ngIf="cart.voucher != null">Cupom: {{cart.voucher.name | uppercase}}.</small></dt>
                  <dd class="text-sm font-medium text-gray-900">- R${{cart.price_discount | number:'1.2-2'}}</dd>
                </div>
              </ng-container>

              <div class="flex items-center justify-between border-t border-gray-200 pt-4">
                <dt class="text-base font-medium text-gray-900">Total</dt>
                <div class="flex flex-col items-end">
                  <dd class="text-base font-medium text-gray-900">R${{cart.price_accumulated | number:'1.2-2'}}</dd>
                  <ng-container *ngIf="marketplace?.payment?.credit_card_max_installment_no_fee > 0"> <p class="text-sm font-medium text-gray-900">Até {{marketplace.payment.credit_card_max_installment_no_fee}}x sem juros*</p> </ng-container>
                </div>
              </div>
            </dl>

            <div class="mt-6">
              <button [routerLink]="['/p/checkout']" [queryParams]="{uid: cart.client_marketplace_cart_uid}" type="submit" class="bg-pink-800 rounded-full space-x-2 w-full h-12 lg:px-4 hover:bg-pink-900">
                <div class="flex justify-center items-center space-x-1">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <p class="text-white text-sm font-semibold lg:text-base">Finalizar Compra</p>
                </div>
              </button>
            </div>
            <div class="mt-4">
              <button [routerLink]="['/s']" class="border border-gray-500 rounded-full space-x-2 w-full p-2 hover:bg-gray-200">
                <div class="flex justify-center items-center">
                  <p class="text-xs lg:text-sm">Escolher mais produtos</p>
                </div>
              </button>
            </div>
            <ng-container *ngIf="!cart.awaiting_user_apply_delivery_method">
              <div class="mt-4">
                <p class="text-sm text-gray-600 pb-2">Recalcular Entrega</p>
                <div class="flex justify-between items-center space-x-2 lg:justify-start">
                  <input type="text" type="text" value="{{cart.zipcode}}" placeholder="CEP" #zipcode class="focus:outline-none border border-gray-200 rounded-lg placeholder-gray-400 px-6 py-2 text-sm w-full" />
                  <button (click)="collectiveMarketplaceCartServicePriceDelivery();" class="bg-[#FFBE0B] rounded-lg text-black px-4 py-3 text-sm font-medium hover:bg-amber-500">Calcular</button>
                </div>
              </div>
            </ng-container>
            <div class="mt-4">
              <p class="text-sm text-gray-600 pb-2">Aplicar Cupom</p>
              <dd class="flex justify-between items-center space-x-2 lg:justify-start">
                <input type="text" id="" name="voucher" [(ngModel)]="voucher" [ngModelOptions]="{standalone: true}" class="focus:outline-none border border-gray-200 rounded-lg placeholder-gray-400 px-6 py-2 text-sm w-full" placeholder="CUPOM" />
                <button (click)="collectiveMarketplaceCartServiceVoucher();" class="bg-a[#FFBE0B] rounded-lg text-black px-4 py-3 text-sm font-medium hover:bg-amber-500">Aplicar</button>
              </dd>
            </div>
            <div class="mt-4">
              <p class="text-pink-800 font-bold text-sm pb-2">OBSERVAÇÕES*</p>
              <div class="flex items-center space-x-2 no-scrollbar lg:justify-start lg:items-start">
                <div class="border-2 border-gray-200 shrink-0 w-40 rounded-lg">
                  <p class="text-center p-4 text-xs">Você pode aplicar <span class="font-semibold">1 Cupom</span> por Compra.</p>
                </div>

                <div class="border-2 border-gray-200 shrink-0 w-40 rounded-lg">
                  <p class="text-center p-4 text-xs">Descontos não são acumulativos.</p>
                </div>
              </div>
            </div>
          </section>
        </form>
      </ng-container>
    </ng-container>
  </div>
</main>

<!-- Modal tipo de entrega -->
<p-dialog header="Entrega no CEP: {{cart?.zipcode}}" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'1920px': '40vw', '960px': '40vw', '640px': '80vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <div *ngIf="price_delivery?.shippingServices">
    <div class="flex w-full items-center justify-between my-4" *ngFor="let delivery of price_delivery.shippingServices">
      <div class="relative flex items-center space-x-3 rounded-lg w-full border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400 cursor-pointer">
        <div class="flex-shrink-0">
          <img class="h-10 w-10 rounded-full" src="https://cdn-icons-png.flaticon.com/512/45/45880.png" alt="Caminhão de entrega" />
        </div>
        <div class="min-w-0 flex-1" (click)="collectiveMarketplaceCartServiceApplyDeliveryMethod(delivery)">
          <a class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">{{delivery.name}}</p>
            <p class="truncate text-sm text-gray-500">Prazo de Entrega: {{delivery.days}} dias úteis.</p>
            <p class="truncate text-sm text-gray-500">Valor da Entrega: R$ {{delivery.price | number:'1.2-2'}}.</p>
          </a>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="displayModal=false">Fechar</button>
  </ng-template>
</p-dialog>

<ng-template #loading>
  <div class="my-10">
    <nav aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-4">
        <li>
          <div role="status" class="max-w-sm animate-pulse">
            <div class="bg-gray-200 rounded w-48 h-3 mb-4"></div>
          </div>
        </li>
      </ol>
    </nav>
    <div class="sm:grid sm:grid-cols-2 lg:items-start lg:gap-x-8 pt-12">
      <div class="cols-span-2 flex flex-col space-y-4">
        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
          <div class="flex items-center justify-center w-full h-44 bg-gray-300 rounded"></div>
        </div>
        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
          <div class="flex items-center justify-center w-full h-44 bg-gray-300 rounded"></div>
        </div>
      </div>
      <div class="cols-span-1 mt-10 sm:mt-16 sm:px-0 lg:mt-0 flex flex-col space-y-4">
        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center w-full">
          <div class="flex items-center justify-center w-full h-96 bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
